<template>
    <v-layout wrap class="advogados">
        <v-flex md12 sm12 xs12 class="titulo-centro">
            <h2> ADVOGADOS  </h2>

            <div class="risquinho-centro"></div>


        </v-flex>

        <v-flex md6 sm12 xs12 class="container-avatar">
            <v-layout column>
                <v-flex xs12>
                    <v-avatar size="50%">
                        <img :src="luiz">
                    </v-avatar>
                </v-flex>

                <v-flex class="avatar-name">
                    <h5><strong>Luiz Eduardo Peccinin</strong></h5>
                </v-flex>

                <v-flex xs12>
                    <p class="avatar-text">Doutor e Mestre em Direito do Estado pela Universidade Federal do Paraná. Bacharel em Ciências Jurídicas pela Faculdade de Direito da Universidade Federal do Paraná. Especialista em Direito Administrativo pelo Instituto de Direito Romeu Felipe Bacellar e especialista em Direito Eleitoral pela Universidade Positivo. Autor do livro 
                    <a target="_blank" href="http://loja.editoraforum.com.br/o-discurso-religioso-na-politica-brasileira-democracia-e-liberdade-religiosa-no-estado-laico">
                        <b>“O Discurso Religioso na Política Brasileira: Democracia e Liberdade Religiosa no Estado Laico”</b>
                    </a> 
                    e Organizador do
                    <a target="_blank" href="http://loja.editoraforum.com.br/colecao-tratado-de-direito-eleitoral?search=tratado%20de%20direito%20eleitoral">
                        <b> “Tratado de Direito Eleitoral”</b>
                    </a>. Membro da ABRADEP - Academia Brasileira de Direito Eleitoral e Político.</p>
                </v-flex>

                <v-flex  xs12>
                    <p><strong>Email:</strong> luizeduardo@peccininealessi.adv.br</p>
                </v-flex>

            </v-layout>
        </v-flex>

        <v-flex md6 sm12 xs12 class="container-avatar">
            <v-layout column>
                <v-flex xs12>
                    <v-avatar size="50%">
                        <img :src="dylliardi">
                    </v-avatar>
                </v-flex>

                <v-flex class="avatar-name">
                    <h5><strong>Dylliardi Alessi</strong></h5>
                </v-flex>

                <v-flex xs12>
                    <p class="avatar-text">Mestre em Direito Econômico e Desenvolvimento pela Pontifícia Universidade Católica do Paraná (PUC/PR). Bacharel em Direito pelo Centro Universitário Curitiba (Unicuritiba). Graduado em Administração de Empresas pela Universidade Federal do Paraná (UFPR), com ênfase em Administração Internacional de Negócios. Especialista em Direito Eleitoral e autor de diversos artigos científicos, palestrante e professor. Presidente da Comissão de Acompanhamento Legislativo da Ordem dos Advogados do Brasil, Seccional Paraná. Diretor Legislativo e da Escola do Legislativo da Assembleia Legislativa do Estado do Paraná.</p>
                </v-flex>

                <v-flex  xs12>
                    <p><strong>Email:</strong> dylliardi@peccininealessi.adv.br</p>
                </v-flex>

            </v-layout>
        </v-flex>

        <v-flex md6 sm12 xs12 class="container-avatar">
            <v-layout column>
                <v-flex xs12>
                    <v-avatar size="50%">
                        <img :src="lygia">
                    </v-avatar>
                </v-flex>

                <v-flex class="avatar-name">
                    <h5><strong>Lygia Maria Copi</strong></h5>
                </v-flex>

                <v-flex xs12>
                    <p class="avatar-text">Advogada. Doutora em Direito na Universidade Federal do Paraná. Mestre e bacharel em Direito pela Universidade Federal do Paraná. Professora do Curso de Direito do Centro Universitário UNIVEL. Membro do Núcleo de Pesquisa "Virada de Copérnico" junto à UFPR. Autora de diversos artigos na área do Direito Civil.</p>
                </v-flex>

                <v-flex class="avatar-email"  xs12>
                    <p><strong>Email:</strong> lygia@peccininealessi.adv.br</p>
                </v-flex>
            </v-layout>

        </v-flex>

        <v-flex md6 sm12 xs12 class="container-avatar">
            <v-layout column>
                <v-flex xs12>
                    <v-avatar size="50%">
                        <img :src="priscilla">
                    </v-avatar>
                </v-flex>

                <v-flex class="avatar-name">
                    <h5><strong>Priscilla Conti Bartolomeu</strong></h5>
                </v-flex>

                <v-flex xs12>
                    <p class="avatar-text">Advogada. Doutoranda e Mestre em Direito do Estado pela Universidade Federal do Paraná. Graduada em Direito pela Faculdade de Direito da Universidade Federal do Paraná. Membro do Instituto Política por.de.para Mulheres. Editora Executiva da Revista da Faculdade de Direito da UFPR.</p>
                </v-flex>

                <v-flex xs12>
                    <p><strong>Email:</strong> priscilla@peccininealessi.adv.br </p>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex md6 sm12 xs12 class="container-avatar">
            <v-layout column>
                <v-flex xs12>
                    <v-avatar size="50%">
                        <img :src="jeancarlo">
                    </v-avatar>
                </v-flex>

                <v-flex class="avatar-name">
                    <h5><strong>Jeancarlo Coletti</strong></h5>
                </v-flex>

                <v-flex  xs12>
                    <p class="avatar-text">Advogado. Procurador da Câmara Municipal de Itaperuçu, graduado em Direito pela Universidade Federal do Paraná. Pós-graduado em Segurança Pública e Atividade Policial na Faculdade de Direito Padre Arnaldo Janssen. </p>
                </v-flex>


            </v-layout>
            <v-flex class="avatar-email" xs12>
                <p><strong>Email:</strong> jeancarlo@peccininealessi.adv.br</p>
            </v-flex>
        </v-flex>

        <v-flex md6 sm12 xs12 class="container-avatar">
            <v-layout column>
                <v-flex xs12>
                    <v-avatar size="50%">
                        <img :src="rodrigo">
                    </v-avatar>
                </v-flex>

                <v-flex class="avatar-name">
                    <h5><strong>Rodrigo Bittencourt B. O.</strong></h5>
                </v-flex>

                <v-flex  xs12>
                    <p class="avatar-text">Advogado. Pós-graduando em Direito Processual Civil pela Pontifícia Universidade Católica do Paraná. Graduado em Direito pela Pontifícia Universidade Católica do Paraná. </p>
                </v-flex>


            </v-layout>
            <v-flex class="avatar-email" xs12>
                <p><strong>Email:</strong> rodrigo@peccininealessi.adv.br</p>
            </v-flex>
        </v-flex>

        <v-flex md6 sm12 xs12 offset-lg-3 offset-md-0 class="container-avatar ">
            <v-layout column>
                <v-flex xs12>
                    <v-avatar size="50%">
                        <img :src="mirian">
                    </v-avatar>
                </v-flex>

                <v-flex class="avatar-name">
                    <h5><strong>Mirian de Boit</strong></h5>
                </v-flex>

                <v-flex  xs12>
                    <p class="avatar-text">Advogada, possui MBA em Gestão Jurídica no Instituto de Pós-graduação e Graduação (IPOG), especialista em Direito Tributário Empresarial e bacharel em Direito pela Pontifícia Universidade Católica do Paraná. Ainda, é Data Protection Officer (DPO) pela Itcerts, membro da Associação Nacional dos Profissionais de Privacidade de Dados (ANPPD) e Secretária da Comissão de Defesa das Prerrogativas e da Valorização Profissional da Subseção de Criciúma/SC. </p>
                </v-flex>


            </v-layout>
            <v-flex class="avatar-email" xs12>
                <p><strong>Email:</strong> mirian@peccininealessi.adv.br</p>
            </v-flex>
        </v-flex>

    </v-layout>
</template>

<script>
import luiz from '../assets/luiz.jpg'
import dylliardi from '../assets/dylliardi.png'
import lygia from '../assets/lygia.jpg'
import jeancarlo from '../assets/jeancarlo.jpg'
import priscilla from '../assets/priscilla.jpg'
import rodrigo from '../assets/rodrigo.jpeg' 
import mirian from '../assets/mirian.png' 


export default {
    data () {
        return {
            luiz,
            dylliardi,
            lygia,
            jeancarlo,
            priscilla,
            rodrigo,
            mirian
        }
    }
}
</script>

<style scoped>

    a:hover {
        text-decoration: underline #6ba348 !important;
    }

    a {
        color: #6ba348;
    }
    
    .links a{
        text-decoration: underline #6ba348 !important;
        color: #272727;
    }

    .container-avatar {
        position: relative;
        text-align: center;
        align-items: center;
        margin-bottom: 36px;
        justify-content: center;
    }

     .container-avatar-centered {
        position: relative;
        text-align: center;
        align-items: center;
        margin-bottom: 36px;
        justify-content: center;
    }

    .avatar-name {
        margin-top: 2.5%;
        margin-bottom: 3%;
    }

    .avatar-text {
        display: block;
        padding-left: 10%;
        padding-right: 10%;
    }

    .avatar-email {
        /*position: absolute;*/
        /*text-align: center;*/
        /*bottom: 0;*/
    }
</style>
